/**
 * Helper to simulate delay
 * Usage: await wait(5000) // waits 5 sec.
 * @param ms
 */
export const wait = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))
